import { useTranslation } from "react-i18next";
import deleteIcon from "../../../../assets/img/save_export/delete.svg";
import WarningModal from "./../../../custom-modal/index";
import { useAppDispatch } from "Redux/hooks";
import { removeBusiness } from "Redux/middlwares/business";
import { fetchUser } from "Redux/middlwares/user";
import { timeout_secs } from "Constants/alert-modal";
import toast from 'react-hot-toast';

function DeleteCompanyModal(props) {
  const {
    onHide,
    companytoDelete,
  } = props;
  const { t } = useTranslation(["common", "warning"]);
  const dispatch = useAppDispatch();

  const handleDeleteBusiness = () => {
    dispatch(
      removeBusiness(companytoDelete.id, (deleted) => {
        if (deleted) {
          dispatch(fetchUser)
          toast((t("company deleted alert", { ns: "warning" })), {
            icon: <img src={deleteIcon} alt="alert icon" />,
          });
          onHide();
        }
      })
    );
  };


  const btnValues = [
    {
      text: t("cancel", { ns: "common" }),
      btnClass: "custom__btn-secondary",
    },
    {
      text: t("Delete", { ns: "common" }),
      btnClass: "custom__btn-primary",
    },
  ];

  const btnFunctions = {
    primary: handleDeleteBusiness,
    secondary: onHide,
  };

  return (
    <WarningModal
      show={props.show}
      onHide={props.onHide}
      dialogClassName={"modal_width"}
      btnFunctions={btnFunctions}
      btnValues={btnValues}
      modalColor={"#fff"}
    >
      <div className="delete__title pb-md-4 pb-2">
        <p className="mb-0">{t("delete company surety", { ns: "warning" })}</p>
      </div>
    </WarningModal>
  );
}

export default DeleteCompanyModal;
